/**
 * Classe représentant une étiquette personnalisée avec sélection intégrée
 */
export class CustomTagWithSelect<T, U> {
    libelle: string;
    ngModel: () => U;
    onSelectionChange: (data: U, customTag: CustomTagWithSelect<T, U>) => void;
    options: { libelle: string, value: U }[];
    isError: () => boolean;
    isDisabled: () => boolean;
}

/**
 * Constante sentinelle pour indiquer qu'aucune sélection n'est faite.
 * Mat-Select gère mal la sélection de null, donc on utilise une sentinelle.
 */
export const NO_SELECTION = '__NONE__';